<template>
  <div>
    <back-btn />
    <v-row justify="center">
      <v-col cols="12" md="8">
        <Form @emitDaData="create" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from "@/components/member/Form";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    Form,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    create(payload) {
      console.log(payload);
      this.$store.dispatch("Member/create", payload).then(() => {
        this.$router.push("/member");
      });
    },
  },
};
</script>
